// Product-level (EMR) native-app links — the HomeMD apps serve all tenants,
// so these are deliberately NOT tenant configuration.
export const APP_STORE_URL = 'https://apps.apple.com/ca/app/homemd/id1299088137';
export const APP_STORE_ITMS_URL = 'itms-apps://itunes.apple.com/app/id1299088137';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=ca.homemd.homemd';
export const DEEP_LINK_SCHEME = 'careand';
